import { StorageService } from './../services/storage.service';
import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'utcToLocaleDateTime'
})
export class UtcToLocaleDateTimePipe implements PipeTransform {
  constructor(private storageService: StorageService) { }

  transform(utcDate: Date | string, format: string = "dd.MM.yyyy HH:mm:ss") {
    utcDate = dayjs(utcDate, 'YYYY-MM-DD HH:mm').toDate();
    const localeDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
    const offset = utcDate.getTimezoneOffset() / 60;
    const hours = utcDate.getHours();

    if (utcDate.getDay() !== localeDate.getDay()) {
      localeDate.setHours(24 * (utcDate.getDay() - localeDate.getDay()) + hours - offset);
    } else {
      localeDate.setHours(hours - offset);
    }

    const lang = this.storageService.getStorage(this.storageService.idLanguage)?.replace(/['"]+/g, '');
    return new DatePipe(lang ?? "en").transform(localeDate, format);
  }

}
